import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import {
  PermissionService,
  RouterUtilsService,
  UserStore,
} from '@cxc/core/services';

@Component({
  selector: 'home-guard',
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
/**
 * This component is a hack, in a future version of angular this wouldn't be needed.
 * We need the RedirectFunction released in angular v20: https://angular.dev/api/router/RedirectFunction
 *
 * But because how angular manages routes we need to instance a component that can act as a guard...
 * No, a guard cannot do this, as it will error at runtime.
 */
export class HomeRedirectComponent {
  userStore = inject(UserStore);
  permissionService = inject(PermissionService);
  router = inject(Router);
  routerUtils = inject(RouterUtilsService);

  constructor() {
    const user = this.userStore.get();
    const isStaff = user.entity?.name === 'CXC';
    const hasOverviewPermission = this.permissionService.hasPermission(
      'PORTFOLIO_OVERVIEW_READ'
    );

    if (isStaff) {
      this.router.navigateByUrl('/dashboard/portfolio/facilities');
    } else if (!this.permissionService.hasModuleAccess('PORTFOLIO')) {
      // LEN-2764: the 2FA lands everyone here now; without Portfolio the
      // module guard would refuse the pages below, so go to the first module.
      this.router.navigateByUrl(
        this.routerUtils.getFirstModuleRoutePath(user.modules ?? [])
      );
    } else if (hasOverviewPermission) {
      this.router.navigateByUrl('/dashboard/portfolio/overview');
    } else {
      this.router.navigateByUrl('/dashboard/portfolio/facilities');
    }
  }
}
